import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Must match Administration::GeocodingQueueStream::REFRESH_PAGE_EVENT
const REFRESH_PAGE_EVENT = "admin:refresh-geocoding-queue"

// Re-visits the current geocoding queue frame URL after a row-level Turbo Stream removal
// so the list, empty state, and Pagy controls stay in sync with the latest scope.
export default class extends Controller {
  static values = {
    frameId: String,
    url: String
  }

  connect() {
    this.refreshInFlight = false
    this.refreshQueued = false
    this.boundRefresh = this.scheduleRefresh.bind(this)
    this.boundFrameLoad = this.onFrameLoad.bind(this)
    this.frameCaptureOptions = { capture: true }

    document.addEventListener(REFRESH_PAGE_EVENT, this.boundRefresh)
    // Frame load events do not bubble, so observe them during capture.
    document.addEventListener("turbo:frame-load", this.boundFrameLoad, this.frameCaptureOptions)
  }

  disconnect() {
    document.removeEventListener(REFRESH_PAGE_EVENT, this.boundRefresh)
    document.removeEventListener("turbo:frame-load", this.boundFrameLoad, this.frameCaptureOptions)
  }

  scheduleRefresh() {
    if (this.refreshInFlight) {
      this.refreshQueued = true
      return
    }

    this.refresh()
  }

  onFrameLoad(event) {
    if (!this.hasFrameIdValue || event.target.id !== this.frameIdValue) return

    this.refreshInFlight = false

    if (!this.refreshQueued) return

    this.refreshQueued = false
    this.refresh()
  }

  refresh() {
    if (!this.hasUrlValue || !this.hasFrameIdValue) return

    this.refreshInFlight = true
    Turbo.visit(this.urlValue, { frame: this.frameIdValue, action: "replace" })
  }
}
